import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-insurance',
  templateUrl: './auto-insurance.component.html',
  styleUrls: ['./auto-insurance.component.scss']
})
export class AutoInsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
